// Touch-tolerant hit testing for Mapbox layers. Single place for "which
// feature did the user tap?", so desktop (exact point) and touch (padded area)
// behave consistently everywhere.
import { TOUCH_HIT_RADIUS_PX, isCoarsePointer } from './mobileUtil';

const squaredDistance = (a, b) => (a.x - b.x) ** 2 + (a.y - b.y) ** 2;

// Features of the given layers at, or on touch devices near, the screen point.
// On touch devices they are sorted nearest first.
export const queryFeaturesNearPoint = (map, point, layers) => {
  const existingLayers = (layers || []).filter(id => map.getLayer(id));
  if (!existingLayers.length) return [];
  if (!isCoarsePointer()) {
    return map.queryRenderedFeatures(point, { layers: existingLayers });
  }
  const r = TOUCH_HIT_RADIUS_PX;
  const features = map.queryRenderedFeatures(
    [
      [point.x - r, point.y - r],
      [point.x + r, point.y + r]
    ],
    { layers: existingLayers }
  );
  const distanceOf = feature =>
    feature.geometry && feature.geometry.type === 'Point'
      ? squaredDistance(map.project(feature.geometry.coordinates), point)
      : 0;
  return features
    .map(feature => ({ feature, distance: distanceOf(feature) }))
    .sort((a, b) => a.distance - b.distance)
    .map(item => item.feature);
};

// Replacement for map.on('click', layerId, handler) that tolerates imprecise
// touches. The handler receives the event with `features` set to the hits.
export const onLayerClick = (map, layerId, handler) => {
  map.on('click', e => {
    const features = queryFeaturesNearPoint(map, e.point, [layerId]);
    if (features.length) handler({ ...e, features });
  });
};
